import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines multiple class names using clsx and then merges Tailwind classes using tailwind-merge
 * This helps avoid conflicts when combining conditional Tailwind classes
 * @param {...string} inputs - Class names to combine
 * @returns {string} - Merged class names
 */
export function cn(...inputs: any[]) {
  return twMerge(clsx(inputs));
}
